import { __rest } from "tslib";
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
* import { Checkbox } from "@skve/components"
*
* function Demo() {
*   return (
*     <div className="flex items-center space-x-2">
*       <Checkbox id="terms" />
*       <label
*         htmlFor="terms"
*         className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
*       >
*         Accept terms and conditions
*       </label>
*     </div>
*   )
* }
 * ```
 */
const Checkbox = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(CheckboxPrimitive.Root, Object.assign({ ref: ref, className: cn("peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className) }, props),
        React.createElement(CheckboxPrimitive.Indicator, { className: cn("flex items-center justify-center text-current") },
            React.createElement(Check, { className: "h-4 w-4" }))));
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };
//# sourceMappingURL=checkbox.js.map